import { Avatar, Image } from "@mantine/core";
import { Outlet, useLocation, Link, useSearchParams } from "react-router";
import NavbarItem from "./components/Sidebar/SidebarItem";
import styled from "styled-components";
import { useAuth } from "./context/AuthContext";
import { useState } from "react";
import AreYouSureModal from "./components/common/AreYouSureModal";
import { IconMenu2 } from "@tabler/icons-react";


function App() {
  const { logout, adminUser } = useAuth();
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const location = useLocation();
  const pathMap: Record<string, string> = {
    dashboard: " Ana Sayfa",
    companies: "Şirketler",
    "admin-users": "Admin Kullanıcıları",
    "panel-users": "Panel Kullanıcıları",
    settings: "Ayarlar",
    new: "Yeni",
    edit: "Düzenle",
    detail: "Şirket Detayları",
    employees: "Çalışanlar",
    tablets: "Tabletler",
  };

  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab");

  const tabLabelMap: Record<string, string> = {
    user: "HR Kullanıcıları",
    employee: "Çalışanlar",
    tablet: "Tabletler",
  };

  const tabMap: Record<string, string> = {
    employees: "employee",
    "panel-users": "user",
    tablets: "tablet",
  };

  const segments = location.pathname.split("/").filter(Boolean);

  const detailIndex = segments.indexOf("detail");
  const companyId = detailIndex !== -1 ? segments[detailIndex + 1] : null;
  const detailPath = companyId ? `/companies/detail/${companyId}` : null;

  const breadcrumbs = segments
    .map((segment, index) => ({
      label: pathMap[segment] ?? segment,
      segment: segment,
      fullPath: "/" + segments.slice(0, index + 1).join("/"),
      isId: !!segment.match(/^[a-f0-9]{24}$/),
    }))
    .filter((crumb) => !crumb.isId)
    .map((crumb, _, arr) => {
    const segmentIndex = segments.indexOf(crumb.segment);
    const nextSegment = segments[segmentIndex + 1];
    const nextIsId = nextSegment && !!nextSegment.match(/^[a-f0-9]{24}$/);
   
    
    return {
      ...crumb,
      fullPath: nextIsId
        ? "/" + segments.slice(0, segmentIndex + 2).join("/")
        : crumb.fullPath,
    };
  });

  const breadcrumbsWithTab = activeTab && detailPath
  ? [...breadcrumbs, {
      label: tabLabelMap[activeTab] ?? activeTab,
      segment: activeTab,
      fullPath: `${detailPath}?tab=${activeTab}`,
      isId: false,
    }]
  : breadcrumbs;
   
  return (
    <AppWrapper>
      <Navbar $isOpen={sidebarOpen}>
        <LogoWrapper $isOpen={sidebarOpen}>
          <Link to="/dashboard" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            {sidebarOpen ? (
              <img height={45} style={{ objectFit: "contain", cursor: "pointer" }} src={"/assets/logo.png"} alt="Logo" />
            ) : (
              <img height={28} style={{ objectFit: "contain", cursor: "pointer" }} src={"/assets/kronifyLogo.png"} alt="Logo" />
            )}
            </Link>
        </LogoWrapper>
        <NavbarItemsWrapper $isOpen={sidebarOpen}>
          <NavbarItem
              iconSrc={"/assets/dashboardIcon.png"}
              navigateTo={"/dashboard"}
              title={"Ana Sayfa"}
              sidebarOpen={sidebarOpen}
            />
            <NavbarItem
              iconSrc={"/assets/employeesIcon.png"}
              navigateTo={"/companies"}
              title={"Şirketler"}
              sidebarOpen={sidebarOpen}
            />
            <NavbarItem
              iconSrc={"/assets/usersIcon.png"}
              navigateTo={"/admin-users"}
              title={"Admin Kullanıcıları"}
              sidebarOpen={sidebarOpen}
            />
            <NavbarItem
              iconSrc={"/assets/settingsIcon.png"}
              navigateTo={"/settings"}
              title={"Ayarlar"}
              sidebarOpen={sidebarOpen}
            />  
          </NavbarItemsWrapper>
      </Navbar>

      <ContentWrapper>
        <TopNavbar>
          <TopNavLeft>
            <HamburgerButton onClick={() => setSidebarOpen(!sidebarOpen)}>
              <IconMenu2 size={28} color="#4c4c4c" />
            </HamburgerButton>
            {breadcrumbsWithTab.length > 0 && (
            <BreadcrumbBar>
              {breadcrumbsWithTab.map((crumb, i) => {
                const tabLink = tabMap[crumb.segment] && detailPath
                  ? `${detailPath}?tab=${tabMap[crumb.segment]}`
                  : null;

                return (
                  <span key={crumb.fullPath}>
                    {i > 0 && <Separator>›</Separator>}
                    {i === breadcrumbsWithTab.length - 1 ? (
                      <ActiveCrumb>{crumb.label}</ActiveCrumb>
                    ) : tabLink ? (
                      <CrumbLink to={tabLink}>{crumb.label}</CrumbLink>
                    ) : (
                      <CrumbLink to={crumb.fullPath}>{crumb.label}</CrumbLink>
                    )}
                  </span>
                );
              })}
            </BreadcrumbBar>
          )}
        </TopNavLeft>
          <TopNavRight>
            <AdminInfo>
              <Link to={`/admin-users/edit/${adminUser?._id}`}>
                <Avatar size={36} radius={"xl"} color="#5c26ff">
                  {adminUser?.username?.[0]?.toUpperCase()}
                </Avatar>
                <span>{adminUser?.username}</span>
              </Link>
            </AdminInfo>

              <LogoutButton onClick={() => setOpenLogoutModal(true)}>
                <Avatar src={"/assets/logoutIcon.png"} size={20}></Avatar>
                <span>Çıkış Yap</span>
              </LogoutButton>
              <AreYouSureModal
                opened={openLogoutModal}
                setOpened={setOpenLogoutModal}
                proccessFunc={() => logout()}
                title="Çıkış Yap"
                text="Çıkış yapmak istediğinizden emin misiniz?"
                confirmButtonText="Evet"
                cancelButtonText="Vazgeç"
              />
          </TopNavRight>
        </TopNavbar>
        
        <MainContent>
          <Outlet />
        </MainContent>
      </ContentWrapper>
    </AppWrapper>
  );
}

export default App;

const AppWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
`;

const TopNavbar = styled.nav`
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  padding: 0 10px;
  border-bottom: 1px solid #D9D9D9;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  flex-shrink: 0;
`;

const NavbarItemsWrapper = styled.div<{ $isOpen: boolean }>`
  padding: ${(props) => (props.$isOpen ? "24px 16px" : "24px 8px")};
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const LogoutButton = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 44px;
  width: max-content;
  color: red;
  padding: 12px 25px 12px 16px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  span {
    font-size: 16px;
    color: red;
    font-weight: 600;
    line-height: 20px;
  }
`;

const MainContent = styled.main`
  flex-grow: 1;
  background: #f0f0f5;
  padding: 12px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

const AdminInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 44px;
  padding: 12px 25px 12px 16px;
  a {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
  }
  span {
    font-size: 16px;
    font-weight: 600;
    color: #1D1B20;
  }
`;

const Navbar = styled.nav<{ $isOpen: boolean }>`
  width: ${(props) => (props.$isOpen ? "280px" : "64px")};
  min-width: ${(props) => (props.$isOpen ? "280px" : "64px")};
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #D9D9D9;
  height: 100vh;
  flex-shrink: 0;
  transition: width 0.3s ease, min-width 0.3s ease;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`;

const BreadcrumbBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px; 
  font-weight: 600;
  flex-wrap: nowrap;
  overflow: hidden;
  min-width: 0;
  `;

const Separator = styled.span`
  color: #aaa;
  margin: 0 4px;
`;

const CrumbLink = styled(Link)`
  color: #5c26ff;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover { text-decoration: underline; }
`;

const ActiveCrumb = styled.span`
  color: #4c4c4c;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const LogoWrapper = styled.div<{ $isOpen?: boolean }>`
  padding: 0 20px;
  padding-top: ${(props) => (props.$isOpen ? "20px" : "30px")};
  display: flex;
  align-items: ${(props) => (props.$isOpen ? "center" : "flex-start")};
  height: 90px;
  flex-shrink: 0;
  justify-content: center;
  img {
    object-fit: contain;
    height: ${(props) => (props.$isOpen ? "45px" : "40px")};
    width: auto;
  }
`;

const HamburgerButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  flex-shrink: 0;
  background-color: #ffffff;
  &:hover {
    background-color: #eef2ff;
  }
`;

const TopNavLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  flex: 1;
  min-width: 0;
`;

const TopNavRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
`;
